const es = {
  // Navigation
  nav_plan: 'Planificar',
  nav_itinerary: 'Itinerario',
  nav_saved: 'Guardado',

  // Header
  explore_photos: 'Explorar fotos',
  sign_in: 'Iniciar sesión',

  // Plan screen
  new_trip: '+ Nuevo viaje',
  add_city_header: 'Agregar ciudad',
  city_placeholder: 'Escribe el nombre de una ciudad…',
  add_cities_empty: 'Agrega ciudades para comenzar a planificar tu viaje',
  dest_bangkok: 'Bangkok', dest_paris: 'París', dest_london: 'Londres', dest_dubai: 'Dubái',
  dest_singapore: 'Singapur', dest_tokyo: 'Tokio', dest_new_york: 'Nueva York',
  dest_istanbul: 'Estambul', dest_kuala_lumpur: 'Kuala Lumpur', dest_seoul: 'Seúl',
  hero_badge: 'Planificación de viajes con IA',
  hero_title_line1: 'Tu próximo viaje,',
  hero_title_line2: 'perfectamente planificado.',
  hero_subtitle: 'Toca un destino para empezar a planificar al instante',
  most_visited_label: 'Destinos más visitados',
  popular_destinations: 'Destinos populares',
  or_type_your_own: 'o escribe el tuyo',
  where_going_label: '¿A dónde vas?',
  expanding_region: (r) => `Buscando las mejores ciudades en ${r}…`,
  tap_to_explore: '— toca para explorar',
  attraction_count: (n) => `${n} ${n === 1 ? 'atracción' : 'atracciones'}`,
  show_less: 'Ver menos',
  read_more: 'Leer más',
  more: 'Más',
  less: 'Menos',
  no_attractions: 'Aún no hay atracciones',
  add_attraction_placeholder: (city) => `Agregar atracción en ${city}…`,
  auto_add_title: 'Agregar automáticamente las atracciones recomendadas',
  preferences_label: 'Intereses',
  all_types_label: 'Todos los tipos',
  edit_interests: 'Editar intereses…',
  plan_framing_msg: 'Quédate con lo que te gusta, elimina el resto — luego genera tu plan día a día.',
  add_back: 'Restaurar',
  added_label: 'Añadido',
  refresh_attractions: 'Actualizar atracciones',
  plan_multi_summary: (n, m) => `${n} ${n === 1 ? 'ciudad' : 'ciudades'} · ${m} ${m === 1 ? 'lugar' : 'lugares'}`,
  filter_onboarding_msg: 'Personaliza tus atracciones',
  filter_onboarding_sub: 'Toca un tipo para enfocar — regeneraremos con ese filtro.',
  explore_nearby: 'Explorar lugares cercanos',
  explore_nearby_sub: 'Ve fotos de los imprescindibles de tu viaje',
  finding_attractions: 'Buscando atracciones…',
  finding_attractions_1: 'Consultando a la IA…',
  finding_attractions_2: 'Buscando los mejores lugares…',
  finding_attractions_3: 'Casi listo…',
  generating_msg_1: 'Planificando tus días…',
  generating_msg_2: 'Buscando los mejores lugares…',
  generating_msg_3: 'Creando tu itinerario…',
  view_itinerary: 'Ver itinerario',
  generate_itinerary: 'Generar itinerario',
  filterLabel: (label) => ({ 'All': 'Todo', 'Culture': 'Cultura', 'Nature': 'Naturaleza', 'Entertainment': 'Entretenimiento', 'Shopping': 'Compras', 'Food & Drink': 'Gastronomía', 'Kids': 'Niños', 'Seniors': 'Mayores' })[label] ?? label,

  // Itinerary screen
  rename: 'Renombrar',
  days: (n) => `${n} ${n === 1 ? 'día' : 'días'}`,
  unsaved_dot: 'Cambios sin guardar',
  share_itinerary: 'Compartir itinerario',
  copy: 'Copiar',
  copied: '¡Copiado!',
  add_more_attractions: 'Agregar más atracciones',
  search_city_placeholder: 'Buscar una ciudad…',
  plus_city: '+ Ciudad',
  your_cities: 'Tus ciudades',
  unscheduled_count: (n) => `Atracciones sin programar (${n})`,
  drag_to_schedule: 'Arrastra a un día para programarlas',
  loading_details: 'Cargando detalles…',
  drag_here: 'Arrastra una atracción aquí',
  day_label: (n) => `Día ${n}`,
  activity_count: (n) => `${n} ${n === 1 ? 'actividad' : 'actividades'}`,
  add_note: '+ Agregar nota',
  note_placeholder: 'Notas para este día — hotel, almuerzo, recordatorios…',
  save_note: 'Guardar nota',
  cancel: 'Cancelar',
  continue_in_city: 'Continuar en una ciudad existente',
  change_back: '← Cambiar',
  save: 'Guardar',
  hotel_nights_label: 'Noches',
  hotel_name_label: 'Nombre del hotel',
  restaurant_label: 'Restaurante (opcional)',
  search_hotel: 'Buscar hotel…',
  search_restaurant: 'Buscar restaurante…',
  searching: 'Buscando…',
  address_label: 'Dirección',
  time_label: 'Hora',
  duration_label: 'Duración',
  notes_label: 'Notas',
  time_placeholder: 'p. ej., 9:00 AM',
  duration_placeholder: 'p. ej., 2 horas',
  notes_placeholder: 'p. ej., check-in a las 3 pm, habitación con vista a la piscina…',
  drag_to_reorder: 'Arrastra para reordenar',
  details: 'Detalles',
  edit: 'Editar',
  snip: 'Snip',
  remove: 'Eliminar',
  move_to_day_picker: 'Mover al día…',
  trip_start_date: 'Inicio del viaje',
  itinerary_photo_sub: 'Sugerencias de IA basadas en tus ciudades',
  itinerary_photo_cta: 'Encuentra joyas escondidas para tu viaje',
  hotel: 'Hotel',
  meal_at: (restaurant) => `en ${restaurant}`,
  add_day: 'Agregar día',
  save_changes: 'Guardar cambios',
  saved_check: 'Guardado ✓',
  save_itinerary: 'Guardar itinerario',
  print_export: '🖨️ Imprimir / Exportar PDF',
  photos_details: 'Fotos y detalles',

  // Saved screen
  snip_requires_account: 'Crea una cuenta gratuita para guardar marcadores',
  sign_in_to_save:'Inicia sesión para guardar y ver tus viajes',
  sign_in_or_create: 'Iniciar sesión o crear cuenta',
  snips: 'Snips',
  place_count: (n) => `${n} ${n === 1 ? 'lugar' : 'lugares'}`,
  trips: 'Viajes',
  loading_trips: 'Cargando viajes…',
  no_saved_trips: 'Aún no hay viajes guardados',
  add_to_plan: 'Agregar al plan',
  add_to_itinerary_btn: 'Agregar al itinerario',
  untitled_trip: 'Viaje sin título',
  open: 'Abrir',

  // User menu
  signed_in_as: 'Conectado como',
  change_password: 'Cambiar contraseña',
  delete_user_menu: 'Eliminar usuario',
  sign_out: 'Cerrar sesión',

  // Load saved trip confirmation
  load_trip_confirm_title: '¿Abrir viaje guardado?',
  load_trip_confirm_msg: 'Tu plan actual se descartará. Guárdalo primero si quieres conservarlo.',

  // New trip confirmation
  unsaved_changes_title: 'Cambios sin guardar',
  unsaved_changes_msg: '¿Tu viaje actual tiene cambios sin guardar. ¿Iniciar un viaje nuevo de todas formas?',
  discard_start_new: 'Descartar y empezar nuevo',
  new_trip_tab_title: '¿Empezar un nuevo viaje?',
  new_trip_tab_msg: 'Tu itinerario actual se borrará. Guárdalo primero si quieres conservarlo.',
  start_fresh: 'Empezar de cero',

  // Auth modal
  create_account: 'Crear cuenta',
  email_placeholder: 'Correo electrónico',
  password_placeholder: 'Contraseña',
  i_agree_to: 'Acepto los',
  terms_of_service: 'Términos de servicio',
  privacy_policy: 'Política de privacidad',
  and: 'y la',
  no_account: '¿No tienes cuenta? ',
  have_account: '¿Ya tienes una cuenta? ',
  network_error: 'Error de red, inténtalo de nuevo',
  err_email_exists: 'Ya existe una cuenta con este correo electrónico',
  err_invalid_credentials: 'Correo electrónico o contraseña incorrectos',
  err_email_password_required: 'El correo electrónico y la contraseña son obligatorios',
  err_password_too_short: 'La contraseña debe tener al menos 6 caracteres',

  // Change password modal
  select_user: 'Seleccionar usuario…',
  new_password_placeholder: 'Nueva contraseña (mín. 6 caracteres)',
  update_password: 'Actualizar contraseña',
  password_updated: 'Contraseña actualizada',
  select_a_user: 'Selecciona un usuario',
  network_error_short: 'Error de red',

  // Delete user modal
  delete_user_trips: 'Eliminar usuario y viajes',
  deleted_user: (email) => `${email} eliminado`,

  // Photo mode
  photo_loading_msg_1: 'Buscando lugares increíbles…',
  photo_loading_msg_2: 'Verificando fotos y detalles…',
  photo_loading_msg_3: 'Casi listo…',
  finding_places: 'Buscando lugares para ti…',
  could_not_load_places: 'No se pudieron cargar los lugares',
  no_places: 'No hay lugares para mostrar',
  ai_error: 'Problema con la IA. Inténtalo de nuevo en un momento.',
  add_cities_suggestions: 'Agrega ciudades o guarda lugares para obtener sugerencias personalizadas.',
  retry: 'Reintentar',
  close: 'Cerrar',
  finding_more_places: 'Buscando más lugares…',
  seen_it_all: '¡Ya lo viste todo!',
  photo_limit_msg: 'Alcanzaste el límite de 50 lugares para esta sesión.',
  check_snips: 'Revisa tus Snips para ver los lugares guardados',
  photo_unavailable: 'Foto no disponible',
  loading: 'Cargando…',
  skip: 'Omitir',
  plus_itinerary: '+ Itinerario',
  plus_plan: '+ Plan',
  photo_explore_title: 'Explorar fotos',
  photo_explore_sub: 'Descubre lugares visualmente',
  swipe_lr: 'Desliza izquierda o derecha para omitir',
  swipe_up: 'Desliza hacia arriba para omitir',
  lets_go: 'Vamos',
  tutorial_skip_desc: 'Omitir este lugar',
  tutorial_snip_desc: 'Guardar en tu colección de Snips para revisitar más tarde',
  tutorial_add_plan_desc: 'Agregar a tu pestaña de Plan',
  tutorial_add_itinerary_desc: 'Añadir directamente a tu itinerario actual',
  tutorial_swipe_hint: 'También puedes deslizar izquierda, derecha o hacia arriba para omitir',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: 'Términos',
  privacy: 'Privacidad',
  sample_itineraries: 'Itinerarios de ejemplo',
  browse_all_itineraries: 'Ver todos →',

  // Legal overlay
  back_to_app: '← Volver a SnipTrip',

  // Error boundary
  something_wrong: 'Algo salió mal',
  reload: 'Recargar',

  // Print view
  copy_text: 'Copiar texto',
  copied_check: '✓ Copiado',

  // Logic / computed strings
  copy_of: (name) => `Copia de ${name}`,
  transportation: 'Transporte',
  meal: 'Comida',

  // Chat mode
  chat_mode_link: 'o planifica con IA',
  chat_back: '← Volver a Build',
  chat_input_placeholder: 'Mensaje…',
  chat_error: 'Algo salió mal. ¿Intentar de nuevo?',
  chat_cities_count: (n) => n === 1 ? '1 ciudad' : `${n} ciudades`,
  chat_places_count: (n) => n === 1 ? '1 lugar' : `${n} lugares`,
  chat_no_cities: 'Aún no se han añadido ciudades',

  // Discovery panels
  thinking_where: 'Pensando adónde llevarte…',
  couldnt_load_suggestions: 'No se pudieron cargar las sugerencias. ¿Reintentar?',
  back: '← Atrás',
  no_new_suggestions: 'Sin nuevas sugerencias — prueba otra pregunta.',
  back_to_questions: '← Volver a preguntas',
  dismiss: 'Descartar',
  where_to_next_header: '¿Adónde ir después?',
  describe_place: 'Describe el tipo de lugar…',
  go: 'Ir',
  finding_ideas: 'Buscando ideas…',
  more_attractions: 'Más atracciones…',
  different_angle: 'O explora desde otro ángulo:',
  mood_for: '¿Qué te apetece?',
  back_questions_short: '← Preguntas',
  describe_looking_for: 'Describe lo que buscas…',
  where_to_next_trigger: (city) => city ? `+ ¿Adónde ir después de ${city}?` : '+ ¿Adónde ir después?',
  what_else_trigger: (city) => `+ ¿Qué más debería agregar cerca de ${city}?`,
  day_chip_add_attraction: 'Agregar una atracción',
  day_chip_add_city: 'Agregar una ciudad cercana',
  auto_populate_prompt: (city) => `¿Sugerir atracciones populares para ${city}?`,
  auto_populate_yes: 'Sí, sugerir',
  auto_populate_no: 'No, lo agregaré manualmente',
  or_discover_new: '+ O descubrir un nuevo lugar',
  select: 'Seleccionar',
  add: 'Agregar',
  freeform_cta: 'Algo más — lo describo yo',
};

export default es;
